<template>
  <div>

    <div style="
        margin-top: 30px;
        padding: 0 12px;
      ">
      <LicensePlate v-if="showKeyboard" class="plateKey" style="font-size: 18px" v-model="carNumber"
        @change="handleChange" />
      <!-- <input style="
          width: 90%;
          line-height: 30px;
          border: 1px solid #ccc;
          text-indent: 7px;
          font-size: 18px;
        " placeholder="请输入车牌号" type="text" v-model="carNumber" @input="convertToUppercase(carNumber)" /> -->
    </div>
    <!-- 车牌选择 -->
    <div class="flex mb-2 flex-wrap" style="display: flex; margin: 10px 20px; flex-wrap: wrap;">
      <div class="car_number color3 font-w" style="font-size: 18px;" v-for="(item, index) in carNoList" :key="index">
        <span @click="selcectCarNo(item.carNo)">
          {{ item.carNo }}
          <span style="margin-left:20rpx;" @click.stop="delCarNumber(item)">×</span>
        </span>
        <div class="bottomBorder"></div>
      </div>
    </div>
    <div style="
        width: 100;
        text-align: center;
        margin-top: 20px;
        margin-bottom: 50px;
      ">
      <button style="
          background: #4dbf7a;
          width: 90%;
          border: none;
          color: #fff;
          line-height: 40px;
          font-size: 16px;
          border-radius: 6px;
        " @click="searchCar">
        查询
      </button>
    </div>
    <!-- 包月记录 -->
    <!-- <div style="padding-left: 12px" v-show="isShowMonthlyHistory">
          <div style="text-align: start; font-size: 18px; font-weight: bold">
            包月记录
          </div>
          <div style="background: #fff">
            <div
              style="
                display: flex;
                justify-content: space-between;
                padding: 12px;
                font-size: 14px;
              "
            >
              <span style="color: #666">包月类型</span>
              <span>{{ monthlyInfo.MothlyTypeName }}</span>
            </div>
            <div
              style="
                display: flex;
                justify-content: space-between;
                padding: 12px;
                font-size: 14px;
              "
            >
              <span style="color: #666">包期期限</span>
              <span>{{ monthlyInfo.DateStart }} 到 {{ monthlyInfo.DateEnd }}</span>
            </div>
          </div>
        </div> -->
    <!-- 包月信息 -->
    <div style="padding-left: 12px" v-show="isShowMonthkyInfo">
      <div style="margin: 10px 0; font-size: 22px">
        {{ parkingName }}
      </div>
      <div style="text-align: start; font-size: 18px; font-weight: bold">
        包月信息
      </div>
      <div style="background: #fff">
        <div style="
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 12px;
            font-size: 14px;
          ">
          <span style="color: #666">开始时间</span>
          <span>{{ startTime }}</span>
        </div>
        <div style="
            display: flex;
            justify-content: space-between;
            padding: 12px;
            font-size: 14px;
          ">
          <span style="color: #666">包月车牌</span>
          <span>{{ carNumberShow }}</span>
        </div>
        <div style="
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 12px;
            font-size: 14px;
          ">
          <span style="color: #666">包月类型</span>
          <div>
            <span v-if="monthlyTypeName">{{ monthlyTypeName }}</span>
            <select v-else id="CarName" style="border: none; color: #4088ff; font-size: 14px" name="CarName"
              v-model="MonthlyType" @change="ceclMonthlyFee(MonthlyType)">
              <!-- TODO -->
              <option :value="item.monthlyTypeName" v-for="(item, index) in monthlyTypeList" :key="index">
                {{ item.monthlyTypeName }}
              </option>
              <!-- <option value="1">月租</option> -->
            </select>
          </div>
        </div>
        <div style="
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 12px;
            font-size: 14px;
          ">
          <span style="color: #666">包月时长</span>
          <div>
            <van-stepper v-model="monthlyNum" button-size="28" disable-input :max="maximumNumberMonthly" />
          </div>
        </div>
        <div style="
            display: flex;
            justify-content: space-between;
            padding: 12px;
            font-size: 14px;
          ">
          <span style="color: #666">包月期限</span>
          <span>{{ startTime }} 到 {{ endTime }}</span>
        </div>
        <div style="
            display: flex;
            justify-content: space-between;
            padding: 12px;
            font-size: 14px;
          ">
          <span style="color: #666">包月费用</span>
          <span>￥{{ monthlyMoney }}</span>
        </div>
        <van-divider />
        <div style="
            display: flex;
            justify-content: space-between;
            padding: 12px;
            font-size: 14px;
          ">
          <span style="color: #666">用户姓名</span>
          <input type="text" v-model="carUsername" placeholder="请输入用户姓名" maxlength="10"
            style="border: none; text-align: end" />
        </div>
        <div style="
            display: flex;
            justify-content: space-between;
            padding: 12px;
            font-size: 14px;
          ">
          <span style="color: #666">手机号码</span>
          <input type="text" v-model="carUserphone" placeholder="请输入手机号码" maxlength="11"
            style="border: none; text-align: end" />
        </div>
        <!-- 提交按钮 -->
        <div style="padding: 14px 15px">
          <!-- 续租提交 -->
          <button v-if="isRenewal == 1" style="
              background: #4088ff;
              width: 100%;
              border: none;
              color: #fff;
              line-height: 40px;
              font-size: 16px;
              border-radius: 44px;
            " @click="submitMonthlyClound">
            确认提交
          </button>
          <!-- 新申请 -->
          <button v-else style="
              background: #4088ff;
              width: 100%;
              border: none;
              color: #fff;
              line-height: 40px;
              font-size: 16px;
              border-radius: 44px;
            " @click="submitNewMonthly">
            确认提交
          </button>
        </div>
      </div>
    </div>
    <van-dialog v-model="showDialog" title="包月订单已生成" :showConfirmButton="false" close-on-click-overlay width="100%">
      <div style="padding: 0 20px">
        <p>请核对以下包月信息</p>
        <van-divider :style="{ margin: '10px 0' }" />
        <div class="mt-2" style="#4E5969">
          <div class="flex1 mb-2">
            <div class="">【包月时间】</div>
            <div class="">{{ startTime }} 至 {{ endTime }}</div>
          </div>
          <div class="flex1 mb-2">
            <div class="">【包月车牌】</div>
            <div class="">
              {{ monthlyOrderDialogInfo.carNumber }}
            </div>
          </div>
          <div class="flex1">
            <div class="">【包月费用】</div>
            <div style="color: #165dff; font-size: 28px">
              ￥{{ monthlyOrderDialogInfo.monthlyFee }}
            </div>
          </div>
        </div>

        <div class="flex" style="padding-bottom: 10px; justify-content: center">
          <van-button type="info" style="
              width: 125px;
              height: 38px;
              line-height: 38px;
              background-color: #165dff;
              color: #fff;
              border-radius: 4px;
            " size="large" @click="goPay">立即支付</van-button>
        </div>
      </div>
    </van-dialog>
    <div style="
        color: #929196;
        width: 100%;
        margin-top: 10px;
        padding-bottom: 30px;
      ">
      <h2 style="
          text-align: center;
          font-size: 14px;
          font-weight: bold;
          margin-top: 2px;
        ">
        温馨提示
      </h2>
      <p style="
          line-height: 30px;
          margin: 0 auto;
          width: 90%;
          font-size: 14px;
          text-align: start;
        ">
        1、请在上方输入框输入车牌号后点击查询进行包月操作；<br />
        2、包月申请及续费时请确保车牌号无误；<br />
      </p>
    </div>
  </div>
</template>

<script>
import { queryMonthlyApplyInfoCloud, miniProgramCloud, addCloudMiniPrsonalMonthlyOrder, cloudMiniProgramMonthlyOrder, miniPrsonalMonthlyOrderCheckCloud, } from '@/api/Monthly'
import { getWxUserLoginH5, getAliUserLoginH5, cloudGetHistoryCarNumber, cloudAddHistoryCarNumber, cloudDelHistoryCarNumber } from '@/api/h5'
import {
  Toast
} from 'vant'
export default {
  props: {

  },
  data() {
    return {
      carNoList: [],
      carNumber: '',
      carNumberShow: '',
      MonthlyType: '',
      parkId: '',
      areaId: '',
      infoId: '',
      monthlyMain: '',
      carUsername: '',
      carUserphone: '',

      startTime: '',
      endTime: '',
      monthlyNum: 1,
      //   包月查询信息
      monthlyInfo: {},
      //   包月查询信息
      monthlyApply: {},
      //   是否续租 0申请 1续租
      isRenewal: 0,
      //   包月费用
      monthlyMoney: 0,
      //  应付
      monthlyMoneyPrice: 0,
      isShowMonthkyInfo: false,
      //  包月记录
      isShowMonthlyHistory: false,

      maximumNumberMonthly: 99,

      showDialog: false,
      monthlyOrderDialogInfo: {},
      monthlyType: '1',
      monthlyTypeList: [],
      authCode: '',
      code: '',

      //   包月类型
      cycle: '',
      monthlyInfoId: '',
      calcMonthlyPrice: 1,
      monthlyTypeName: '',
      parkingName: '',
      sourceType: 1, // 1 微信 2 支付宝
      showKeyboard: true  // 控制键盘是否显示
    };
  },
  components: {

  },
  computed: {

  },
  watch: {
    monthlyNum(val) {
      // TODO
      let monthlyMsg = this.monthlyTypeList.find((item) => {
        return item.monthlyTypeId === this.cycle;
      });

      if (monthlyMsg.monthlyTypeId == 1) {
        this.calculateEndDate(this.startTime, val)
      } else if (monthlyMsg.monthlyTypeId == 2) {
        this.getDateAfterQuarters(this.startTime, val)
      } else if (monthlyMsg.monthlyTypeId == 3) {
        this.getDateAfterHalfYears(this.startTime, val)
      } else if (monthlyMsg.monthlyTypeId == 4) {
        this.getDateAfterYears(this.startTime, val)
      }

      this.caleMonthlyFee(val)
    }
  },
  created() {
    var url = window.location.href;
    var params = this.parse_url(url);

    this.parkId = params.parkId
    this.areaId = params.areaId
    this.infoId = params.infoId
    this.monthlyMain = params.monthlyMain
    // this.code = params.code
    // console.log('获取公众号code', params);
    if (params.source == 'alipay_wallet') {
      this.sourceType = 2
      this.authCode = params.auth_code
      this.initALiOrderInfo()
    } else {
      this.code = params.code
      this.initOrderInfo()
    }

  },
  mounted() {

  },
  methods: {
    handleChange(val) {
      // val 包含 array, value, pass 等属性
      console.log('车牌变化:', val.value, '是否通过验证:', val.pass)
      this.carNumber = val.value
    },
    selcectCarNo(i) {
      this.carNumber = i
    },
    async getCarNumberList() {
      const { data } = await cloudGetHistoryCarNumber({
        openId: sessionStorage.getItem('Token'),
        type: 2, // 1预支付 2包月
        currentPage: 1,
        pageSize: 5
      })

      if (data.code == 200) {
        this.carNoList = data.rows
      }
    },
    // 新增车牌号
    async addCarNumber() {
      const { data } = await cloudAddHistoryCarNumber({
        openId: sessionStorage.getItem('Token'),
        type: 2, // 1预支付 2包月
        carNo: this.carNumber
      })
      if (data.code == 200) {
        this.getCarNumberList()
      }
    },
    // 删除车牌号
    async delCarNumber(i) {
      const { data } = await cloudDelHistoryCarNumber({
        ids: [i.id]
      })
      if (data.code == 200) {
        Toast('删除成功')
        this.getCarNumberList()
      }
    },
    convertToUppercase(value) {
      // 输入发生变化时，自动将小写字母转为大写
      this.carNumber = value.toUpperCase();
    },
    // 支付宝初始化获取信息
    async initALiOrderInfo() {
      /*
          获取链接code
          获取车牌号
          获取车场id
          获取区域id
      */
      const { data } = await getAliUserLoginH5({
        // 动态获取
        authCode: this.authCode,
        parkId: this.parkId,
      })
      if (data.code == 200) {
        if (Object.entries(data.data).length) {
          const res = data.data
          sessionStorage.setItem('Token', res.token)
          this.getCarNumberList()
        } else {
          Toast('登录失败，请重新扫描二维码')
        }
      } else {
        Toast(data.msg)
      }
    },
    // 初始化获取信息
    async initOrderInfo() {
      /*
          获取链接code
          获取车牌号
          获取车场id
          获取区域id
      */
      const { data } = await getWxUserLoginH5({
        // 动态获取
        code: this.code,
        parkId: this.parkId,
      })
      if (data.code == 200) {
        if (Object.entries(data.data).length) {
          const res = data.data
          sessionStorage.setItem('Token', res.token)
          this.getCarNumberList()
        } else {
          Toast('登录失败，请重新扫描二维码')
        }
      } else {
        Toast(data.msg)
      }
    },
    //转码
    parse_url(url) { //定义函数
      var pattern = /(\w+)=(\w+)/ig; //定义正则表达式
      var parames = {}; //定义数组
      url.replace(pattern, function (a, b, c) {
        parames[b] = c;
      });
      return parames; //返回这个数组.
    },
    // 车牌号校验正则表达式
    validateLicensePlate(plateNumber) {

      // 新能源
      let xny = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}(([0-9]{5}[DF]$)|([A-HJ-K][A-HJ-NP-Z0-9][0-9]{4}$))/;

      // 燃油车
      let ryc = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳]{1}$/;

      if (plateNumber.length == 7) {
        return ryc.test(plateNumber)
      } else if (plateNumber.length == 8) {
        return xny.test(plateNumber)
      }
    },
    // 手机号校验正则表达式
    validateLicensePhone(carUserphone) {

      // 手机号
      let xny = /^(1[3-9])\d{9}$/

      if (carUserphone.length == 11) {
        return xny.test(carUserphone)
      }
    },

    async searchCar() {
      this.showKeyboard = false
      this.$nextTick(() => {
        this.showKeyboard = true
      })

      if (!this.carNumber) {
        Toast('请输入车牌号进行查询')
        this.isShowMonthkyInfo = false
        return
      }
      if (!this.validateLicensePlate(this.carNumber)) {
        Toast('请输入正确的车牌号查询')
        this.isShowMonthkyInfo = false
        return
      }
      this.addCarNumber()
      Toast.loading({
        message: '查询中...',
        forbidClick: true,
        duration: 0
      });
      const { data } = await queryMonthlyApplyInfoCloud({
        carNumber: this.carNumber,
        parkId: this.parkId,
        areaId: this.areaId,
        infoId: this.infoId,
        monthlyMain: this.monthlyMain
      })
      if (data.code == 200) {
        Toast.clear()
        // 是否展示包月信息
        this.isShowMonthkyInfo = true

        // 包月续租
        if (data.data.monthlyApply) {
          this.isRenewal = 1
          this.monthlyNum = 1
          // 初始化的金额
          this.parkingName = data.data.parkName
          this.monthlyMoney = data.data.price
          this.cycle = data.data.cycle
          this.monthlyTypeName = data.data.cycleName
          this.monthlyInfoId = data.data.monthlyApply.infoId
          this.calcMonthlyPrice = data.data.discount
          this.carNumberShow = data.data.carNumber
          //   this.monthlyInfo = data.data.cycle
          this.monthlyMoneyPrice = data.data.price
          this.monthlyApply = data.data.monthlyApply
          this.MonthlyType = data.data.cycleName
          this.monthlyTypeList = data.data.monthlyInfoList
          this.startTime = this.formatDate(data.data.monthlyApply.endTime)

          // 默认获取二维码包月步长信息
          const info = data.data.monthlyInfoList.find(item => item.infoId === data.data.monthlyApply.infoId)
          this.maximumNumberMonthly = info.maximumNumberMonthly

          //  半年初始化
          if (data.data.cycle == 1) {
            this.calculateEndDate(this.startTime, 1)
          } else if (data.data.cycle == 2) {
            this.getDateAfterQuarters(this.startTime, 1)
          } else if (data.data.cycle == 3) {
            this.getDateAfterHalfYears(this.startTime, 1)
          } else if (data.data.cycle == 4) {
            this.getDateAfterYears(this.startTime, 1)
          }
          //   this.getNextMonthDate(this.startTime)
          console.log('this.startTime', this.startTime);
        }
        // 申请包月
        else {
          // 创建一个新的 Date 对象，表示当前日期
          const currentDate = new Date();
          // 获取当前的年、月、日
          const year = currentDate.getFullYear();
          const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // 月份从 0 开始，所以加 1
          const day = String(currentDate.getDate()).padStart(2, '0');
          this.isRenewal = 0
          this.monthlyNum = 1

          this.startTime = `${year}-${month}-${day}`
          this.getNextMonthDate(this.startTime)
          this.carNumberShow = data.data.carNumber
          //   this.monthlyInfo = data.data.monthlyInfo
          // 初始化的金额
          this.parkingName = data.data.parkName
          this.monthlyMoney = data.data.monthlyInfoList[0].discount
          this.cycle = data.data.monthlyInfoList[0].monthlyTypeId
          this.monthlyInfoId = data.data.monthlyInfoList[0].infoId
          this.calcMonthlyPrice = data.data.monthlyInfoList[0].discount
          //   TODO
          this.MonthlyType = data.data.monthlyInfoList[0].monthlyTypeName
          this.monthlyTypeList = data.data.monthlyInfoList
        }
      } else {
        Toast.clear()
      }

    },
    // 包月信息提交续租
    async submitMonthlyClound() {
      if (!this.carUsername) {
        Toast('请输入姓名')
        return
      }
      if (!this.validateLicensePhone(this.carUserphone)) {
        Toast('请输入正确的手机号')
        return
      }
      Toast.loading({
        message: '提交中...',
        forbidClick: true,
        duration: 0
      });
      const response = await miniPrsonalMonthlyOrderCheckCloud({
        monthlyApplyCode: this.monthlyApply.monthlyApplyCode,
        applyId: this.monthlyApply.id,
        startTime: `${this.startTime} 00:00:00`,
        areaId: this.areaId,
        parkId: this.parkId,
        monthlyMain: this.monthlyMain,
        endTime: `${this.endTime} 23:59:59`,
        price: this.monthlyMoney,
        carUsername: this.carUsername,//联系人姓名
        carUserphone: this.carUserphone,//联系电话
        actualToll: this.monthlyMoney,
        duration: this.monthlyNum,
        monthlyFee: this.monthlyMoney,
        isRenewal: 1,
        token: sessionStorage.getItem('Token')
      })
      if (response.data.code == 200) {
        const { data } = await addCloudMiniPrsonalMonthlyOrder({
          monthlyApplyCode: this.monthlyApply.monthlyApplyCode,
          applyId: this.monthlyApply.id,

          areaId: this.areaId,
          parkId: this.parkId,
          monthlyMain: this.monthlyMain,
          endTime: `${this.endTime} 23:59:59`,
          price: this.monthlyMoney,
          carUsername: this.carUsername,//联系人姓名
          carUserphone: this.carUserphone,//联系电话
          actualToll: this.monthlyMoney,
          duration: this.monthlyNum,
          monthlyFee: this.monthlyMoney,
          isRenewal: 1,
          token: sessionStorage.getItem('Token')
        })
        if (data.code == 200) {
          this.monthlyOrderDialogInfo = data.data
          this.showDialog = true
          Toast.clear()
        } else {
          Toast.clear()
          Toast(data.msg);
        }
      }
      else {
        Toast.clear()
        Toast(response.data.msg);
      }
    },
    async submitNewMonthly() {
      if (!this.carUsername) {
        Toast('请输入姓名')
        return
      }
      if (!this.validateLicensePhone(this.carUserphone)) {
        Toast('请输入正确的手机号')
        return
      }
      Toast.loading({
        message: '提交中...',
        forbidClick: true,
        duration: 0
      });
      const { data } = await miniProgramCloud({
        monthlyMain: 1,//包月主体
        parkId: this.parkId,
        areaId: this.areaId,
        infoId: this.monthlyInfoId,
        cycle: this.cycle,
        type: 1, //1一位一车 2一位多车 3多位多车
        startTime: `${this.startTime} 00:00:00`,//开始时间
        duration: this.monthlyNum, // 包月数量
        purchasedParkingSpaces: 1, // 车位数量
        endTime: `${this.endTime} 23:59:59`,//结束时间
        carNumber: this.carNumber,
        isRenewal: 0,
        carUsername: this.carUsername,//联系人姓名
        carUserphone: this.carUserphone,//联系电话
        paymentType: 1, // 1微信 2支付宝
        monthlyFee: this.monthlyMoney,//应缴费用
        actualToll: this.monthlyMoney,//应缴费用
        userId: this.monthlyInfo.userId,
        token: sessionStorage.getItem('Token')
      })

      if (data.code == 200) {
        const response = await miniPrsonalMonthlyOrderCheckCloud({
          monthlyApplyCode: data.data.monthlyApplyCode,
          startTime: `${this.startTime} 00:00:00`,//开始时间
          duration: this.monthlyNum, // 包月数量
          endTime: `${this.endTime} 23:59:59`,//结束时间
          actualToll: this.monthlyMoney,//应缴费用
          applyId: data.data.id,
          areaId: data.data.areaId,
          parkId: data.data.parkId,
          monthlyMain: data.data.monthlyMain,
          token: sessionStorage.getItem('Token')
        })
        if (response.data.code == 200) {
          const res = await addCloudMiniPrsonalMonthlyOrder({
            monthlyApplyCode: data.data.monthlyApplyCode,
            applyId: data.data.id,
            areaId: data.data.areaId,
            parkId: data.data.parkId,
            monthlyMain: data.data.monthlyMain,
            token: sessionStorage.getItem('Token')
          })
          if (res.data.code == 200) {
            Toast.clear()
            this.monthlyOrderDialogInfo = res.data.data
            this.showDialog = true
          }
          else {
            Toast.clear()
            Toast(res.data.msg);
          }
        }
        else {
          Toast.clear()
          Toast(response.data.msg);
        }
      } else {
        Toast.clear()
        Toast(data.msg);
      }
      console.log('新申请', data);
    },
    // 拉起支付
    async goPay() {
      Toast.loading({
        message: '支付中...',
        forbidClick: true,
        duration: 0
      });
      const { data } = await cloudMiniProgramMonthlyOrder({
        monthlySource: this.monthlyOrderDialogInfo.monthlySource,
        id: this.monthlyOrderDialogInfo.monthlyOrderId,
        code: this.monthlyOrderDialogInfo.code,
        parkId: this.monthlyOrderDialogInfo.parkId,
        parkCode: this.monthlyOrderDialogInfo.parkCode,
        // paymentType: 1, // 1微信 2支付宝
        paymentType: this.sourceType, // 1 微信支付宝 2 支付宝支付
        paymentSource: 1,//1==公众号 0==小程序
        token: sessionStorage.getItem('Token')
      })
      if (data.code == 200) {
        const res = data.data
        /**
         * 西安银行支付（微信、支付宝）
         * 判断是否存在isJump 且 == 1  ==>  西安银行支付
         * 取 jumpUrl： webview  跳转链接
         */
        // 西安银行支付跳转
        if (res?.isJump == 1) {
          window.location.href = res.jumpUrl
        }
        else {
          // 微信支付
          if (this.sourceType == 1) {
            // 由于微信内置对象加载需要时间
            if (typeof WeixinJSBridge == "undefined") {
              if (document.addEventListener) {
                document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady, false);
              } else if (document.attachEvent) {
                document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady);
                document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady);
              }
            } else {
              this.onBridgeReady(res);
            }
          }
          // 支付宝支付
          else {
            this.ALiPayReady(res)
          }
          Toast.clear()
        }
      } else {
        Toast(data.msg);
      }
    },

    onBridgeReady(data) {
      WeixinJSBridge.invoke(
        'getBrandWCPayRequest', {
        appId: data.appid,       	 // 公众号id
        timeStamp: data.timestamp,   	 // 时间戳
        nonceStr: data.noncestr,     	 // 随机串
        package: data.packageValue,         // 订单详情扩展字符串
        signType: data.signType,     	 // 微信签名方式
        paySign: data.sign          // 微信签名
      },
        (res) => {
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            //res.err_msg将在用户支付成功后返回ok，这时调取你本身服务端业务查询，若已支付成功，则跳转成功页面，展示给用户。
            this.$router.replace('successPage')
          }
        });
    },
    // 支付宝拉起支付
    ALiPayReady(data) {
      AlipayJSBridge.call("tradePay", {
        tradeNO: data.tradeNo
      },
        (data) => {
          if ("9000" == data.resultCode) {
            this.$router.replace('successPage')
          }
          else {
            alert("支付失败")
          }
        });
    },
    formatDate(dateString) {
      // 创建一个 Date 对象
      const inputDate = new Date(dateString);

      // 获取年、月、日
      const year = inputDate.getFullYear();
      const month = String(inputDate.getMonth() + 1).padStart(2, '0'); // 月份从 0 开始，所以加 1
      const day = String(inputDate.getDate()).padStart(2, '0');

      // 拼接成所需的格式
      return this.addOneDay(`${year}-${month}-${day}`)
    },
    addOneDay(dateStr) {
      let date = new Date(dateStr);  // 将字符串转换为 Date 对象
      date.setDate(date.getDate() + 1);  // 加一天
      return date.toISOString().split('T')[0];  // 格式化为 yyyy-mm-dd 格式
    },
    subtractOneDay(dateStr) {
      let date = new Date(dateStr);  // 将字符串转换为 Date 对象
      date.setDate(date.getDate() - 1);  // 减去一天
      return date.toISOString().split('T')[0];  // 格式化为 yyyy-mm-dd 格式
    },
    // 选择包月类型病传递包月的信息
    ceclMonthlyFee(info) {
      // 每次变动先清空包月时长
      this.monthlyNum = 1


      let monthlyMsg = this.monthlyTypeList.find((item) => {
        return item.monthlyTypeName === info;
      });
      console.log(monthlyMsg, '寻找到的数据');
      if (monthlyMsg.monthlyTypeId == 1) {
        this.getNextMonthDate(this.startTime, 1)
      } else if (monthlyMsg.monthlyTypeId == 2) {
        this.getDateAfterQuarters(this.startTime, 1)
      } else if (monthlyMsg.monthlyTypeId == 3) {
        this.getDateAfterHalfYears(this.startTime, 1)
      } else if (monthlyMsg.monthlyTypeId == 4) {
        this.getDateAfterYears(this.startTime, 1)
      }
      this.monthlyMoney = monthlyMsg.discount
      this.calcMonthlyPrice = monthlyMsg.discount
      this.cycle = monthlyMsg.monthlyTypeId
      this.monthlyInfoId = monthlyMsg.infoId
      this.maximumNumberMonthly = monthlyMsg.maximumNumberMonthly

    },

    getNextMonthDate(inputDate) {
      // 将传入的日期字符串转换为日期对象
      var date = new Date(inputDate);

      // 获取当前日期的年、月、日
      var year = date.getFullYear();
      var month = date.getMonth(); // 月份从 0 开始
      var day = date.getDate();

      // 计算下一个月的年、月
      var nextMonthYear = month === 11 ? year + 1 : year;
      var nextMonth = (month + 1) % 12;

      // 计算下一个月的天数
      var daysInNextMonth = new Date(nextMonthYear, nextMonth + 1, 0).getDate();

      // 如果当前日期的天数大于下一个月的天数，则取下一个月的最后一天
      if (day >= daysInNextMonth) {
        day = daysInNextMonth;
      }

      // 构造并返回下一个月的日期对象
      var nextMonthDate = new Date(nextMonthYear, nextMonth, day);


      // 构造并返回下一个月的日期对象
      var nextMonthDate = new Date(nextMonthYear, nextMonth, day);
      var year = nextMonthDate.getFullYear();
      var month = nextMonthDate.getMonth() + 1; // 月份从 1 开始
      var day = nextMonthDate.getDate();
      // 格式化月份和日期，确保是两位数
      month = month < 10 ? '0' + month : month;
      day = day < 10 ? '0' + day : day;

      this.endTime = this.subtractOneDay(`${year}-${month}-${day}`)
    },

    // 包月
    calculateEndDate(startDate, numberOfMonths) {
      // 将开始时间字符串转换为日期对象
      var startDateObj = new Date(startDate);

      // 获取开始时间的年、月、日
      var startYear = startDateObj.getFullYear();
      var startMonth = startDateObj.getMonth(); // 月份从 0 开始
      var startDay = startDateObj.getDate();

      // 计算 n 个月后的结束时间
      var endYear = startYear;
      var endMonth = startMonth + numberOfMonths;
      var endDay = startDay;

      // 处理跨年的情况
      while (endMonth >= 12) {
        endMonth -= 12;
        endYear++;
      }

      // 计算 n 个月后的结束时间的天数
      var daysInEndMonth = new Date(endYear, endMonth + 1, 0).getDate();

      // 如果开始时间的日期大于结束时间的天数，则取结束时间的最后一天
      if (startDay > daysInEndMonth) {
        endDay = daysInEndMonth;
      }

      // 构造并返回结束时间的日期对象
      var endDate = new Date(endYear, endMonth, endDay);

      // 获取结束时间的年、月、日

      var endYear = endDate.getFullYear();
      var endMonth = endDate.getMonth() + 1; // 月份从 0 开始，所以要加1
      var endDay = endDate.getDate();
      // 格式化月份和日期，确保是两位数
      endMonth = endMonth < 10 ? '0' + endMonth : endMonth;
      endDay = endDay < 10 ? '0' + endDay : endDay;
      // 返回结束时间的日期对象
      this.endTime = this.subtractOneDay(`${endYear}-${endMonth}-${endDay}`)
    },

    // 计算季度包月
    getDateAfterQuarters(startDate, n) {
      // 如果传入的是字符串形式的日期，则转换为 Date 对象
      if (typeof startDate === 'string') {
        startDate = new Date(startDate);
      }

      // 复制 startDate，以免修改原始日期
      var currentDate = new Date(startDate);

      // 增加 n * 3 个月
      currentDate.setMonth(currentDate.getMonth() + 3 * n);

      // 获取年、月、日
      var year = currentDate.getFullYear();
      var month = currentDate.getMonth() + 1; // 月份是从 0 开始的，所以要加 1
      var day = currentDate.getDate();

      // 格式化月份和日期，保证是两位数
      if (month < 10) {
        month = '0' + month;
      }
      if (day < 10) {
        day = '0' + day;
      }

      // 返回 yyyy-mm-dd 格式的日期字符串
      this.endTime = this.subtractOneDay(`${year}-${month}-${day}`)
    },

    // 计算半年包月
    getDateAfterHalfYears(startDate, n) {
      if (typeof startDate === 'string') {
        startDate = new Date(startDate);
      }

      // 修复1：使用 getFullYear/getMonth 手动计算，避免自动修正
      const currentDate = new Date(startDate);
      const targetYear = currentDate.getFullYear();
      const targetMonth = currentDate.getMonth() + 6 * n;
      const targetDay = currentDate.getDate();

      // 创建目标日期（月份从0开始）
      const targetDate = new Date(targetYear, targetMonth, targetDay);

      // 修复2：如果日期溢出，修正为当月最后一天
      if (targetDate.getDate() !== targetDay) {
        targetDate.setDate(0);
      }

      // 修复3：格式化
      const year = targetDate.getFullYear();
      const month = String(targetDate.getMonth() + 1).padStart(2, '0');
      const day = String(targetDate.getDate()).padStart(2, '0');

      // 修复4：如果 subtractOneDay 不存在，先定义它
      if (typeof this.subtractOneDay !== 'function') {
        this.subtractOneDay = function (dateStr) {
          const d = new Date(dateStr);
          d.setDate(d.getDate() - 1);
          return d.toISOString().split('T')[0];
        };
      }

      this.endTime = this.subtractOneDay(`${year}-${month}-${day}`);
    },
    // 计算年包月
    getDateAfterYears(startDate, n) {
      // 如果传入的是字符串形式的日期，则转换为 Date 对象
      if (typeof startDate === 'string') {
        startDate = new Date(startDate);
      }

      // 复制 startDate，以免修改原始日期
      var currentDate = new Date(startDate);

      // 增加 n 年
      currentDate.setFullYear(currentDate.getFullYear() + n);

      // 获取年、月、日
      var year = currentDate.getFullYear();
      var month = currentDate.getMonth() + 1; // 月份是从 0 开始的，所以要加 1
      var day = currentDate.getDate();

      // 格式化月份和日期，保证是两位数
      if (month < 10) {
        month = '0' + month;
      }
      if (day < 10) {
        day = '0' + day;
      }

      // 返回 yyyy-mm-dd 格式的日期字符串
      this.endTime = this.subtractOneDay(`${year}-${month}-${day}`)
    },

    // 计算包月费用
    caleMonthlyFee(val) {
      this.monthlyMoney = val * this.calcMonthlyPrice
    },

    // 获取年月日的数据
    extractYearMonthDay(dateTimeString) {
      // 使用Date对象解析日期时间字符串
      var date = new Date(dateTimeString);

      // 获取年、月、日
      var year = date.getFullYear();
      var month = date.getMonth() + 1; // 月份从 0 开始，所以要加1
      var day = date.getDate();

      // 格式化月份和日期，确保是两位数
      month = month < 10 ? '0' + month : month;
      day = day < 10 ? '0' + day : day;

      // 构建年月日字符串
      var yearMonthDay = year + '-' + month + '-' + day;

      // 返回年月日字符串
      return yearMonthDay;
    }
  },
};
</script>

<style scoped lang="less">
.flex {
  display: flex;
}

.flex1 {
  display: flex;
  justify-content: space-between;
}

.mb-2 {
  margin-bottom: 10px;
}

.mt-2 {
  margin-bottom: 10px;
}

// 车牌号样式
.car_number {
  border: 2px solid #131313;
  border-radius: 5px;
  padding: 3px 8px;
  position: relative;
  margin: 5px 10px 5px 0;
  font-size: 16px;

  .bottomBorder {
    height: 2px;
    width: 100%;
    background-color: #0170E6;
    position: absolute;
    bottom: 0px;
    left: 0;
    border-radius: 0 0 5px 5px;
  }
}
</style>